export default __webpack_public_path__ + "static/media/d-history.a674c0e0.svg";